<template>

  <div id="accordionExample">
        <b-table-simple bordered>
          <b-thead class="entete-anomalie">
            <b-tr>
              <b-th class="colonne">n° Anomalie</b-th>
              <b-th v-for="champ in nomChamps"
                    v-bind:key="champ"
                    class="colonne">{{champ}}
              </b-th>
              <b-th class="colonne">Justification</b-th>
              <b-th class="colonne">Type</b-th>
              <b-th class="colonne">Validation</b-th>
              <b-th class="colonne">Editer</b-th>
            </b-tr>
          </b-thead>
          <b-tbody class ="tableau-anomalie">
            <b-tr v-for="anomalie in anomalies"
                  v-bind:key="anomalie.idAnomalie"
                  v-bind:anomalie="anomalie">
              <b-td> {{anomalie.idAnomalie}}</b-td>
              <b-td v-for ="champ in anomalie.champsLigneAnomalie"
                  v-bind:key="champ.idChampLigneAnomalie"
                  v-bind:champ="champ">{{champ.valeurChamp}}
              </b-td>
              <b-td v-if="anomalie.justification != null">{{anomalie.justification}}</b-td>
              <b-td v-else class="boutton">
                <b-button @click.prevent="anomalie.showModalValidJustifAnomalie = !anomalie.showModalValidJustifAnomalie"
                  align-self="center"
                  title="justifier l'anomalie" >justifier
                </b-button>
              </b-td>

              <b-modal v-model="anomalie.showModalValidJustifAnomalie" class="col-md-12" hide-header hide-footer centered>
                <ModalValidJustifications
                    :idAnomalie="anomalie.idAnomalie"
                    @close="anomalie.showModalValidJustifAnomalie = false"
                    class="col-md-12">
                </ModalValidJustifications>
              </b-modal>

              <b-td>{{anomalie.type}}</b-td>
              <b-td v-if="anomalie.validation == 1" style="color: forestgreen">Validé</b-td>
              <b-td v-else-if="anomalie.validation == 0">
                <p style="color: red"> Refusé</p>
                <p data-toggle="collapse" :data-target="'#collapse' + anomalie.idAnomalie" aria-expanded="true" :aria-controls="'#collapse' + anomalie.idAnomalie" style="text-decoration: underline; cursor: pointer">Voir le commentaire</p>
                <div :id="'collapse' + anomalie.idAnomalie" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                  <p v-if="anomalie.commentaire != null"><strong>{{anomalie.commentaire}}</strong></p>
                  <p v-else><strong>Pas de commentaire pour cette anomalie</strong></p>
                </div>
              </b-td>
              <b-td v-else-if="anomalie.validation == 2"><b-button pill v-on:click="ValidJustif(1,'Justification',anomalie.idAnomalie)">Oui</b-button> <b-button pill>Non</b-button></b-td>
              <b-td v-else></b-td>
              <b-td v-if="anomalie.type != null">
                <b-button @click.prevent ="anomalie.showModalEditerJustifAnomalie = !anomalie.showModalEditerJustifAnomalie " align-self="center"
                     title="editer la justification" >Editer
                </b-button>
              </b-td>

              <b-modal hide-header hide-footer centered>
                <b-form-group class="labelTitre" id="input-group-10" label="Veuillez commenter votre refus " label-for="input-10">
                  <b-form-input id="input-10" v-model="commentaire" type="text"></b-form-input>
                </b-form-group>

                <b-button pill @click="ValidJustif(0,commentaire,anomalie.idAnomalie)" class="nav-link1 m-2">Valider</b-button>
                <b-button pill class="nav-link2 m-2">Annuler</b-button>
              </b-modal>

              <b-modal v-model="anomalie.showModalEditerJustifAnomalie" class="col-md-12" hide-header hide-footer centered>
                <ModalEditerJustif
                    :idAnomalie="anomalie.idAnomalie"
                    @close="anomalie.showModalEditerJustifAnomalie = false"
                    class="col-md-12">
                </ModalEditerJustif>
              </b-modal>

            </b-tr>
          </b-tbody>
        </b-table-simple>
  </div>

</template>

<script>
import useAnomaliesItem from "@/composition/Rapports/anomaliesFromRequete";
import ModalValidJustifications from '@/components/Rapports/ValidJustifications';
import ModalEditerJustif from '@/components/Rapports/EditerJustif.vue';

export default {
  name: 'AnomaliesItem',

  components:{
    ModalValidJustifications,
    ModalEditerJustif,
  },

  props: {
    idExecution:{
      type:Number
    },
    idRequete:{
      type:Number
    },
    anomalies:{
      required:true,
      type:Array
    },
    nomChamps:{
      type:Array
    },

  },
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  setup(props) {
    return useAnomaliesItem(props);
  },
};
</script>

<style>
.colonne{
  width: 120px;
}
.tableau-anomalie{
  font-size: 13px;
  text-align : center;
  background-color: white;
}
.entete-anomalie{
  font-size: 13px;
  background-color: silver;
  text-align : center;
}
</style>